import { API_DOMAIN } from "@monorepo/constants";
import { INotification } from "@monorepo/types";
import { createApi } from "@reduxjs/toolkit/query/react";

import { customBaseQuery } from "../../helpers/baseQuery";

export const notificationsApi = createApi({
  reducerPath: "notificationsApi",
  baseQuery: customBaseQuery<{ data: Array<INotification> | INotification }>({
    baseUrl: API_DOMAIN,
  }),
  tagTypes: ["Notifications", "Notification"],
  endpoints: (builder) => ({
    getNotifications: builder.query<Array<INotification>, void>({
      query: () => ({
        url: "/api/v1/notifications",
      }),
      providesTags: ["Notifications"],
    }),
    getNotificationById: builder.query<INotification, string>({
      query: (id) => ({
        url: `/api/v1/notifications/${id}`,
      }),
      providesTags: ["Notification"],
    }),
    markAllNotificationsRead: builder.mutation<void, void>({
      query: () => ({
        url: "/api/v1/notifications/read-all",
        method: "PUT",
      }),
      invalidatesTags: ["Notifications"],
    }),
  }),
});

export const { useGetNotificationsQuery, useGetNotificationByIdQuery, useMarkAllNotificationsReadMutation } =
  notificationsApi;

export default notificationsApi.reducer;
